import {Pipe, PipeTransform} from '@angular/core';
import {ExternalReferenceService} from '../services/external-reference.service';

/**
 * EXTERNAL REFERENCE PIPE
 *
 * Returns whether the app is running in external-reference mode.
 * Useful for template bindings where a getter or service injection
 * would require touching the component's TS.
 *
 * The value is constant for the whole session (cached by ExternalReferenceService),
 * so the pipe is declared pure.
 *
 * USAGE
 *  - Binding:  [showCancelButton]="!(null | siExternalReference)"
 *  - *ngIf:    *ngIf="!(null | siExternalReference)"
 */
@Pipe({
  name: 'siExternalReference',
  pure: true
})
export class ExternalReferencePipe implements PipeTransform {

  constructor(
    private externalReferenceService: ExternalReferenceService
  ) { }

  // _value is unused but required by Angular's template type checker (e.g. null | siExternalReference)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(_value?: unknown): boolean {
    return this.externalReferenceService.isActive();
  }
}
